var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("openstack-uicore-foundation", [], t) : "object" == typeof exports ? exports["openstack-uicore-foundation"] = t() : e["openstack-uicore-foundation"] = t();
}(this, function () {
  return function () {
    "use strict";

    var e = {
        5097: function _(e, t, r) {
          r.d(t, {
            CLEAR_SESSION_STATE: function CLEAR_SESSION_STATE() {
              return a;
            },
            LOGOUT_USER: function LOGOUT_USER() {
              return n;
            },
            RECEIVE_USER_INFO: function RECEIVE_USER_INFO() {
              return s;
            },
            SESSION_STATE_STATUS_UNCHANGED: function SESSION_STATE_STATUS_UNCHANGED() {
              return u;
            },
            SET_LOGGED_USER: function SET_LOGGED_USER() {
              return o;
            },
            UPDATE_SESSION_STATE_STATUS: function UPDATE_SESSION_STATE_STATUS() {
              return i;
            },
            UPDATE_USER_INFO: function UPDATE_USER_INFO() {
              return l;
            }
          });
          r(1116), r(6842), r(9087), r(9558), r(1742);
          var o = "SET_LOGGED_USER",
            n = "LOGOUT_USER",
            s = "RECEIVE_USER_INFO",
            a = "CLEAR_SESSION_STATE",
            i = "UPDATE_SESSION_STATE_STATUS",
            u = "unchanged",
            l = "UPDATE_USER_INFO";
        },
        1742: function _(e, t, r) {
          r.d(t, {
            clearAuthInfo: function clearAuthInfo() {
              return c;
            },
            getIdToken: function getIdToken() {
              return S;
            },
            getOAuth2ClientId: function getOAuth2ClientId() {
              return p;
            },
            getOAuth2IDPBaseUrl: function getOAuth2IDPBaseUrl() {
              return E;
            }
          });
          var o = r(9558);
          r(5812), r(806);
          var n = require("browser-tabs-lock");
          var s = r.n(n);
          var a = require("js-cookie");
          var i = r.n(a);
          r(8041), r(9891), r(5097);
          require("crypto-js/sha256"), require("crypto-js/enc-base64url"), require("crypto-js/enc-hex"), "undefined" != typeof window && (window.crypto || window.msCrypto);
          new (s())();
          var u = "authInfo",
            l = "idToken",
            d = function d() {
              try {
                var _e = (0, o.getFromLocalStorage)(u, !1);
                return _e ? JSON.parse(_e) : null;
              } catch (e) {
                return null;
              }
            },
            c = function c() {
              "undefined" != typeof window && ((0, o.removeFromLocalStorage)(u), i().remove(l));
            },
            S = function S() {
              if ("undefined" != typeof window) {
                var _e2 = d();
                return _e2 ? _e2.idToken : null;
              }
              return null;
            },
            p = function p() {
              return "undefined" != typeof window ? window.OAUTH2_CLIENT_ID : null;
            },
            E = function E() {
              return "undefined" != typeof window ? window.IDP_BASE_URL : null;
            };
        },
        9087: function _(e, t, r) {
          r(2462), r(806), r(8041), r(9236), r(6842), r(9558), r(5097), r(1742);
          var o = function o(e) {
            return function (t) {
              return {
                type: e,
                payload: t
              };
            };
          };
          o("RESET_LOADING"), o("START_LOADING"), o("STOP_LOADING");
        },
        9558: function _(e, t, r) {
          r.d(t, {
            getFromLocalStorage: function getFromLocalStorage() {
              return o;
            },
            removeFromLocalStorage: function removeFromLocalStorage() {
              return n;
            }
          });
          r(5812), r(8041);
          var o = function o(e, t) {
              if ("undefined" != typeof window) {
                var _r = window.localStorage.getItem(e);
                return t && (console.log("getFromLocalStorage removing key ".concat(e)), n(e)), _r;
              }
              return null;
            },
            n = function n(e) {
              "undefined" != typeof window && window.localStorage.removeItem(e);
            };
        },
        1116: function _(e) {
          e.exports = require("@babel/runtime/helpers/defineProperty");
        },
        2462: function _(e) {
          e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
        },
        6842: function _(e) {
          e.exports = require("i18n-react/dist/i18n-react");
        },
        9891: function _(e) {
          e.exports = require("idtoken-verifier");
        },
        5812: function _(e) {
          e.exports = require("moment-timezone");
        },
        806: function _(e) {
          e.exports = require("superagent/lib/client");
        },
        9236: function _(e) {
          e.exports = require("sweetalert2");
        },
        8041: function _(e) {
          e.exports = require("urijs");
        }
      },
      t = {};
    function r(o) {
      var n = t[o];
      if (void 0 !== n) return n.exports;
      var s = t[o] = {
        exports: {}
      };
      return e[o](s, s.exports, r), s.exports;
    }
    (function () {
      r.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return r.d(t, {
          a: t
        }), t;
      };
    })(), function () {
      r.d = function (e, t) {
        for (var o in t) {
          r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
            enumerable: !0,
            get: t[o]
          });
        }
      };
    }(), function () {
      r.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      };
    }(), function () {
      r.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      };
    }();
    var o = {};
    r.r(o), r.d(o, {
      loggedUserReducer: function loggedUserReducer() {
        return p;
      }
    });
    var n = r(1116),
      s = r.n(n),
      a = r(5097),
      i = r(9891),
      u = r.n(i),
      l = r(1742);
    function d(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, o);
      }
      return r;
    }
    function c(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? d(Object(r), !0).forEach(function (t) {
          s()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : d(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    var S = {
        isLoggedUser: !1,
        member: null,
        sessionState: null,
        backUrl: null,
        sessionStateStatus: a.SESSION_STATE_STATUS_UNCHANGED
      },
      p = function p() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : S;
        var t = arguments.length > 1 ? arguments[1] : undefined;
        var r = t.type,
          o = t.payload;
        var n = (0, l.getOAuth2IDPBaseUrl)(),
          s = (0, l.getOAuth2ClientId)();
        switch (r) {
          case a.SET_LOGGED_USER:
            {
              var _r2 = t.payload.sessionState;
              return c(c({}, e), {}, {
                isLoggedUser: !0,
                sessionState: _r2,
                backUrl: null,
                sessionStateStatus: a.SESSION_STATE_STATUS_UNCHANGED
              });
            }
          case a.UPDATE_SESSION_STATE_STATUS:
            {
              var _r3 = t.payload.sessionStateStatus;
              return c(c({}, e), {}, {
                sessionStateStatus: _r3
              });
            }
          case a.CLEAR_SESSION_STATE:
            return (0, l.clearAuthInfo)(), c(c({}, e), {}, {
              isLoggedUser: !1,
              sessionState: null,
              backUrl: null
            });
          case a.LOGOUT_USER:
            return (0, l.clearAuthInfo)(), c(c({}, S), {}, {
              backUrl: o.backUrl
            });
          case a.RECEIVE_USER_INFO:
            {
              var _r4 = t.payload.response;
              if ("" !== n && "" !== s) {
                var _e3 = new (u())({
                    issuer: n,
                    audience: s
                  }).decode((0, l.getIdToken)()),
                  _t = _e3.payload.groups || [],
                  _o = _e3.payload.address || {};
                _t = _t.map(function (e) {
                  return {
                    id: e.id,
                    title: e.name,
                    description: e.name,
                    code: e.slug,
                    created: e.created_at,
                    last_edited: e.updated_at
                  };
                }), _r4 = c(c({}, _r4), {}, {
                  groups: [].concat(_toConsumableArray(_r4.groups), _toConsumableArray(_t)),
                  address: _o
                });
              }
              return c(c({}, e), {}, {
                member: _r4
              });
            }
          case a.UPDATE_USER_INFO:
            {
              var _r5 = t.payload;
              return c(c({}, e), {}, {
                member: _r5
              });
            }
          default:
            return e;
        }
      };
    return o;
  }();
});